import { PartialWithId } from '../../types/interfaces';

import {
  BackupDbFailureAction,
  BackupDbRequestAction,
  BackupDbSuccessAction,
  CreateUpdateDatabaseRequestAction,
  DeleteDatabaseSuccessAction,
  GetBdbSyncSourcesFailureAction,
  GetBdbSyncSourcesRequestAction,
  GetBdbSyncSourcesSuccessAction,
  GetDatabasesFailureAction,
  GetDatabasesRequestAction,
  GetDatabasesSuccessAction,
  ImportDbFailureAction,
  ImportDbRequestAction,
  ImportDbSuccessAction,
  RefreshDbSuccessAction,
  ResetBdbValidationStateAction,
  ResetImportDbStateAction,
  StartDatabasesPollingRequestAction,
  ValidateBdbSyncSourcesFailureAction,
  ValidateBdbSyncSourcesRequestAction,
  ValidateBdbSyncSourcesRequestActionPayload,
  ValidateBdbSyncSourcesSuccessAction,
  UserUpdateSubsPriceConfirmationAction,
  CreateUpdateDatabaseRequestPayload,
  SetNewPriceDataAction,
  NewPriceData,
  SetNewDbRcpPlanAction,
  CancelCreateUpdateDbAction,
  UpdateDbRequestAction,
  UpdateDbPayload,
  SetShouldShowClusteringDialogAction,
  UserClusteringConfirmationAction,
  SetDBtablePageSizeAction,
  UpdateDbSuccessAction,
  CreateDbSuccessAction,
  BdbById,
  SetShowRedisStackCongratulationsAction,
  SetDbsStatusAction,
  UserBdbOptimizationAction,
  SetShouldShowBdbOptimizationDialogAction
} from './databases.types';

export const startDatabasesPolling = (
  enableGetBdbsOptimizedQuery: boolean
): StartDatabasesPollingRequestAction => ({
  type: 'START_DATABASES_POLLING',
  payload: enableGetBdbsOptimizedQuery
});

export const getDatabases = (enableGetBdbsOptimizedQuery: boolean): GetDatabasesRequestAction => ({
  type: 'GET_DATABASES_REQUEST',
  payload: enableGetBdbsOptimizedQuery
});

export const setDatabasesStatus = (payload: ReducerStateStatus): SetDbsStatusAction => ({
  type: 'SET_DBS_STATUS',
  payload
});

export const getDatabasesSuccess = (data: BdbById): GetDatabasesSuccessAction => ({
  type: 'GET_DATABASES_SUCCESS',
  payload: data
});

export const getDatabasesFailure = (error: string): GetDatabasesFailureAction => ({
  type: 'GET_DATABASES_FAILURE',
  payload: error
});

export const createUpdateDBRequest = (
  payload: CreateUpdateDatabaseRequestPayload
): CreateUpdateDatabaseRequestAction => ({
  type: 'CREATE_UPDATE_DB_REQUEST',
  payload
});

export const UpdateDBSuccessAction = (payload: Bdb): UpdateDbSuccessAction => ({
  type: 'UPDATE_DB_SUCCESS',
  payload
});

export const CreateDBSuccessAction = (payload: Bdb): CreateDbSuccessAction => ({
  type: 'CREATE_DB_SUCCESS',
  payload
});

export const updateDBRequest = (payload: UpdateDbPayload): UpdateDbRequestAction => ({
  type: 'UPDATE_DB_REQUEST',
  payload
});

export const userUpdateSubsPriceConfirmation = (
  confirmed: boolean
): UserUpdateSubsPriceConfirmationAction => ({
  type: 'USER_UPDATE_SUBS_PRICE_CONFIRMATION',
  payload: confirmed
});

export const setNewPriceData = (payload: NewPriceData): SetNewPriceDataAction => ({
  type: 'SET_NEW_PRICE_DATA',
  payload
});

export const setNewDbRcpPlan = (payload: RcpPlanStatusResponse): SetNewDbRcpPlanAction => ({
  type: 'SET_NEW_DB_RCP_PLAN',
  payload
});

export const setShouldShowClusteringDialog = (): SetShouldShowClusteringDialogAction => ({
  type: 'SET_SHOULD_SHOW_CLUSTERING_DIALOG'
});

export const setShouldShowBdbOptimizationDialog = (): SetShouldShowBdbOptimizationDialogAction => ({
  type: 'SET_SHOULD_SHOW_OPTIMIZATION_DIALOG'
});

export const clusteringConfirmation = (): UserClusteringConfirmationAction => ({
  type: 'USER_CLUSTERING_CONFIRMATION'
});

export const bdbOptimizationConfirmation = (): UserBdbOptimizationAction => ({
  type: 'USER_BDB_OPTIMIZATION_CONFIRMATION'
});

export const cancelCreateUpdateDb = (): CancelCreateUpdateDbAction => ({
  type: 'CANCEL_CREATE_UPDATE_DB'
});

export const deleteDBSuccess = (deletedBdb: Bdb): DeleteDatabaseSuccessAction => ({
  type: 'DELETE_DB_SUCCESS',
  payload: deletedBdb
});

export const getBdbSyncSourcesRequest = (
  cloudProvider: string,
  bdbId?: number
): GetBdbSyncSourcesRequestAction => ({
  type: 'GET_BDB_SYNC_SOURCES_REQUEST',
  payload: { cloudProvider, bdbId }
});
export const getBdbSyncSourcesSuccess = (data: ReplicaItem[]): GetBdbSyncSourcesSuccessAction => ({
  type: 'GET_BDB_SYNC_SOURCES_SUCCESS',
  payload: data
});
export const getBdbSyncSourcesFailure = (error: string): GetBdbSyncSourcesFailureAction => ({
  type: 'GET_BDB_SYNC_SOURCES_FAILURE',
  payload: error
});

export const validateBdbSyncSourceRequest = (
  requestData: ValidateBdbSyncSourcesRequestActionPayload['requestData'],
  cb: ValidateBdbSyncSourcesRequestActionPayload['cb']
): ValidateBdbSyncSourcesRequestAction => ({
  type: 'VALIDATE_BDB_SYNC_SOURCES_REQUEST',
  payload: { requestData, cb }
});
export const validateBdbSyncSourcesSuccess = (): ValidateBdbSyncSourcesSuccessAction => ({
  type: 'VALIDATE_BDB_SYNC_SOURCES_SUCCESS'
});
export const validateBdbSyncSourcesFailure = (
  error: string
): ValidateBdbSyncSourcesFailureAction => ({
  type: 'VALIDATE_BDB_SYNC_SOURCES_FAILURE',
  payload: error
});
export const resetBdbValidationState = (): ResetBdbValidationStateAction => ({
  type: 'RESET_DBD_VALIDATION_STATE'
});

export const refreshDbSuccess = (bdb: PartialWithId<Bdb>): RefreshDbSuccessAction => ({
  type: 'REFRESH_DB_SUCCESS',
  payload: bdb
});

export const backupDbRequest = (bdbId: number): BackupDbRequestAction => ({
  type: 'BACKUP_DB_REQUEST',
  payload: bdbId
});

export const backupDbSuccess = (): BackupDbSuccessAction => ({
  type: 'BACKUP_DB_SUCCESS'
});

export const backupDbFailure = (): BackupDbFailureAction => ({
  type: 'BACKUP_DB_FAILURE'
});

export const importDbRequest = (payload: ImportDbRequestPayload): ImportDbRequestAction => ({
  type: 'IMPORT_DB_REQUEST',
  payload
});

export const importDbSuccess = (): ImportDbSuccessAction => ({
  type: 'IMPORT_DB_SUCCESS'
});

export const importDbFailure = (error: string): ImportDbFailureAction => ({
  type: 'IMPORT_DB_FAILURE',
  payload: error
});

export const resetImportDbState = (): ResetImportDbStateAction => ({
  type: 'RESET_IMPORT_DB_STATE'
});

export const setDBtablePageSize = (pageSize: number): SetDBtablePageSizeAction => ({
  type: 'SET_DB_TABLE_PAGE_SIZE',
  payload: pageSize
});

export const setShowRedisStackCongratulations = (
  showRedisStackCongratulations: boolean
): SetShowRedisStackCongratulationsAction => ({
  type: 'SET_SHOW_REDIS_STACK_CONGRATULATIONS',
  payload: showRedisStackCongratulations
});
